import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {route} from '../../../conf/routes'
import {_API} from './_Action'
import {_PAGINATE} from './paginateAction'
import { CotationCriteria } from 'src/type/criteria/cotationCriteria'

export const COTATIONS = 'cotations'
const _COTATIONS_PAGINATE = _PAGINATE(COTATIONS)

export const fetchCotations = (criteria?: CotationCriteria) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [_COTATIONS_PAGINATE.REQUEST, _COTATIONS_PAGINATE.SUCCESS, _COTATIONS_PAGINATE.FAILURE],
      route: route.cotations.fetch(enterpriseId, criteria)
    }
  })
}

export const sizeCotations = (status: string) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const actions = _API('fetch_size_cotations')
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.cotations.fetch(enterpriseId, {status} as CotationCriteria)
    }
  })
}



// WEBPACK FOOTER //
// ./src/core/redux/action/cotationsAction.ts